/*eslint-disable */
<template>
  <b-container class="modal-Box" fluid>
    <b-row>
      <b-col lg="12">
        <iq-card :class="{ 'remove_card': propOpenedInModal }">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">
              {{ cvCardTitle }}
            </h4>
          </template>
          <template>
            <p v-if="!propOpenedInModal">
              {{ cvCardSubHeader }}
            </p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label
                    for="validationsubs_trial_end">
                    {{cvPaytidLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.subs_tid"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationorder_id">
                    {{cvOrderIdLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.order_id"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationsubs_collection_method">
                    {{cvamountLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.amount"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationplanId"> {{cvPlanIdLabel}}</label>
                 <multiselect
                    v-model="selectedPlanObj"
                    :options="planIdList"
                    :placeholder="'Select Plan'"
                    label="subs_plan_name"
                    track-by="subs_plan_id"
                  >
                    <span slot="noResult">No plans found</span>
                  </multiselect>
                </div>
              </div>
              <div class="form-group row spinner_add">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning">
                  </b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="subscriptionAdd()">
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from "vue-multiselect"
import { Subscriptions } from "../../../FackApi/api/Subscription/subscription"
import ApiResponse from "../../../Utils/apiResponse.js"
import userPermission from "../../../Utils/user_permission.js"
import { socialvue } from "../../../config/pluginInit.js"
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan"
import { PayTransactionss } from "../../../FackApi/api/PayTransactions"

export default {
  name: "SubscriptionAdd",
  components: {
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propPaySubsObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      apiName: "subscription_add",
      cvCardTitle: "Add subscription",
      cvCardSubHeader: "Add subscription",
      cvSubmitBtn: "Add",
      cvPaytidLabel: "Pay tid",
      cvOrderIdLabel: "order id",
      cvPlanIdLabel: "Plan Id",
      cvamountLabel: "Plan Amount",
      cvStatusLabel: "status",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Subscription",
      vmSubscriptionFormData: Object.assign({}, this.initFormData()),
      planIdList: [],
      vmSubscriptionDesc: null,
      vmSubscriptionType: null,
      payTransactionData: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    selectedPlanObj: {
      get () {
        return this.planIdList.find(
          p => p.subs_plan_id === this.vmSubscriptionFormData.subs_plan_id
        ) || null
      },
      set (plan) {
        this.vmSubscriptionFormData.subs_plan_id = plan ? plan.subs_plan_id : ""
      }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    await this.getPlanNames()
    await this.payTransactionsView()
    socialvue.index()
  },
  methods: {
    /**
     * onPlanChange
    */
    onPlanChange (selectedId) {
      this.vmSubscriptionFormData.subs_plan_id = selectedId
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "subs_tid": "",
        "order_id": "",
        "amount": "",
        "subs_plan_id": "",
        "module_obj_id": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSubscriptionFormData) {
          if (!this.vmSubscriptionFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * subscriptionAdd
     */
    async subscriptionAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        this.vmSubscriptionFormData.module_obj_id = this.payTransactionData.user_id
        let subscriptionAddResp = await Subscriptions.subscriptionAdd(this, this.vmSubscriptionFormData)
        if (subscriptionAddResp.resp_status) {
          await ApiResponse.responseMessageDisplay(this, subscriptionAddResp)
          if (subscriptionAddResp && !subscriptionAddResp.resp_status) {
            return false
          }
          //  Emit if opened in Modal
          if (this.propOpenedInModal) {
            this.$emit("emitCloseSubscriptionAddModal", subscriptionAddResp.resp_data)
          }
          this.vmSubscriptionFormData = Object.assign({}, this.initFormData())
        }
        else {
          this.toastMsg = "Data already available"
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at subscriptionAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * payTransactionsView
     */
    async payTransactionsView () {
      try {
        let payTransactionsId = this.propPaySubsObj.pay_tid
        let payTransactionsViewResp = await PayTransactionss.payTransactionsView(this, payTransactionsId)
        if (payTransactionsViewResp && payTransactionsViewResp.resp_status) {
          this.payTransactionData = payTransactionsViewResp.resp_data.data
          this.vmSubscriptionFormData.module_type = "STUDENT"
          this.vmSubscriptionFormData.user_id = this.payTransactionData.user_id
          this.vmSubscriptionFormData.subs_tid = this.payTransactionData.pay_tid
          this.vmSubscriptionFormData.amount = this.payTransactionData.pay_amount
          this.vmSubscriptionFormData.order_id = this.payTransactionData.pay_order_id
          this.vmSubscriptionFormData.subs_plan_id = this.payTransactionData.pay_subs_id
        }
      }
      catch (err) {
        console.error("Exception occurred at payTransactionsView() and Exception:", err.message)
      }
    },
    /**
     * getPlanNames
     */
    async getPlanNames () {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this)
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    }
  }
}
</script>
